import React from 'react';
import {Link} from "react-router-dom";
import {useLocation} from "react-router";
import {
  Subletter,
  SubletterQueryDocument,
  useSubletterMutationMutation
} from '../../generated/graphql';
import {SideList} from "../../components/SideList";
import {FieldTableColumnProps} from "../../components/FieldTable/FieldTableTypes";

/*
function convertVariables(initialValues,values) {
  graphqlSetLookups([]);
  var res = graphqlObjectToInput(initialValues, values);
  delete res.name;
  return {input:res};
}

*/


const Landlords = ()=> {
  const location = useLocation();
  const columns:FieldTableColumnProps<Subletter>[] = [
    {
      accessor:'name',
      header: 'Name',
      dataType:'link',
      options: {
        getLink: ({field, row}) => {
          return ({
            pathname: '/database/landlords/' + row.id,
            search: (location.search ? location.search : '')
          });
        }
      }
    },
    {
      accessor:'email',
      header:'Email',
      className:'column-width-wide-plus',
      dataType:'default'
    }
  ];
  const updateMutation = useSubletterMutationMutation();
  return <SideList searchForm={null} query={SubletterQueryDocument} baseUrl="/database/landlords/" label="Landlords" columns={columns}
  deleteMutation={updateMutation} permission="landlords"
  />;
}
export default Landlords;
